import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/AppScreens/Dashboard/Dashboard"));

const Login = lazy(() => import("../pages/AuthScreens/Login/Login"));
const ForgotPassword = lazy(
  () => import("../pages/AuthScreens/ForgotPassword/ForgotPassword")
);

const UserDetails = lazy(
  () => import("../pages/AppScreens/UserManagement/UserDetails/UserDetails")
);
const UserManagement = lazy(() =>
  import("../pages/AppScreens/UserManagement/UserManagement").then((m) => ({
    default: m.UserManagement,
  }))
);

const Bookings = lazy(
  () => import("../pages/AppScreens/BookingsManagement/Bookings")
);
const BookingDetails = lazy(
  () =>
    import(
      "../pages/AppScreens/BookingsManagement/BookingDetails/BookingDetails"
    )
);

const Withdrawal = lazy(
  () => import("../pages/AppScreens/WithdrawalManagement/Withdrawal")
);
const WithdrawalDetails = lazy(
  () =>
    import(
      "../pages/AppScreens/WithdrawalManagement/WithdrawalDetails/WithdrawalDetails"
    )
);

const Disputes = lazy(() =>
  import("../pages/AppScreens/DisputesManagement/Disputes").then((m) => ({
    default: m.Disputes,
  }))
);
const DisputeDetails = lazy(
  () =>
    import(
      "../pages/AppScreens/DisputesManagement/DisputeDetails/DisputeDetails"
    )
);

const Reviews = lazy(() =>
  import("../pages/AppScreens/ReviewsManagement/Reviews").then((m) => ({
    default: m.Reviews,
  }))
);

const ProfileManagement = lazy(
  () => import("../pages/AppScreens/ProfileManagement/ProfileManagement")
);

const VerificationRequests = lazy(() =>
  import(
    "../pages/AppScreens/VerificationManagement/VerificationRequests"
  ).then((m) => ({ default: m.default }))
);

const VerificationDetailPage = lazy(
  () =>
    import(
      "../pages/AppScreens/VerificationManagement/VerificationDetail/VerificationDetail"
    )
);

const ProductRequests = lazy(() =>
  import(
    "../pages/AppScreens/ProductRequestsManagement/ProductRequests"
  ).then((m) => ({ default: m.ProductRequests }))
);

const ProductRequestDetails = lazy(
  () =>
    import(
      "../pages/AppScreens/ProductRequestsManagement/ProductRequestDetails/ProductRequestDetails"
    )
);

export {
  Login,
  ForgotPassword,
  UserManagement,
  UserDetails,
  Dashboard,
  Bookings,
  BookingDetails,
  Withdrawal,
  WithdrawalDetails,
  Disputes,
  DisputeDetails,
  Reviews,
  ProfileManagement,
  VerificationRequests,
  VerificationDetailPage,
  ProductRequests,
  ProductRequestDetails,
};
